import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilterPage,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import UseSalesReturn from './hooks/useSalesReturn';
import advanceFilterIcon from '../../../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../../assets/image/AddFilter.svg';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import { ExportTable } from '../../../../store/action/export/Export';
import { useState } from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../../helper';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import Pagination from '../../../../component/pagination';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import CustomAlertModel from '../../components/customAlertModel';
import { hasPermission } from '../../../../utils/controller';
import Button from '../../../../component/ui/Button';
import DataNotFound from '../../../components/dataNotFound';

const SalesReturn = () => {
	const {
		user,
		salesReturn,
		bulkAction,
		suburl,
		navigate,
		setBulkAction,
		deselectRows,
		handlePrintAndDownloadPdf,
		headerDropDown,
		FilterDatalist,
		isAdvanceFilterApplied,
		dispatch,
		sortDirection,
		sortDataList,
		setHeaderDropDown,
		setIsAdvanceFilterOpen,
		handleApplyFilters,
		selectedInputs,
		handleOnFocusSelectedFilterInput,
		isLoading,
		isBulkDeleteModelOpen,
		setIsBulkDeleteModalOpen,
		deleteBulkReturnList,
		isAdvanceFilterOpen,
		salesReturnParams,
		handleDeselectAll,
		onRowClick,
		searchSelectedInputItems,
		handlePageChange,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		handleOpenBulkReturnModal,
		handleBulkDeleteSalesReturn,
		setSalesReturnParams,
	} = UseSalesReturn();
	const [isSortBy, setIsSortBy] = useState(false);
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const exportTableData = (param) => {
		ExportTable(param);
	};

	const salesReturnColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 93,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
				>
					<div className="w-auto">
						<p className="table-header__label_invoices mb-0">
							DATE
							<span className="sort-icon">{sortIconMap[sortDirection?.date]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'SALES RETURN #',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 70,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => <p className="text-start mb-0">{params.data['return_number']}</p>,
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'return_number' })}
				>
					<p className="table-header__label_invoices mb-0">
						<p className="d-none d-lg-block mb-0">SALES RETURN #</p>
						<p className="d-block d-lg-none mb-0">SALES</p>
						<span className="sort-icon">{sortIconMap[sortDirection?.return_number]}</span>
					</p>
				</div>
			),
		},
		{
			field: 'CUSTOMER NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 120,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
				>
					<p className="table-header__label_invoices mb-0">
						<p className="d-none d-lg-block mb-0">CUSTOMER NAME</p>
						<p className="d-block d-lg-none mb-0">CUSTOMER</p>
						<span className="sort-icon">{sortIconMap[sortDirection?.customer_name]}</span>
					</p>
				</div>
			),
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 70,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'status' })}
				>
					<p className="table-header__label_invoices mb-0">
						STATUS
						<span className="sort-icon">{sortIconMap[sortDirection?.status]}</span>
					</p>
				</div>
			),
		},
		{
			field: 'RECEIVED STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 90,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'received_status' })}
				>
					<p className="table-header__label_invoices mb-0">
						<p className="d-none d-lg-block mb-0">RECEIVED STATUS</p>
						<p className="d-block d-lg-none mb-0">REC. STA.</p>
						<span className="sort-icon">{sortIconMap[sortDirection?.received_status]}</span>
					</p>
				</div>
			),
		},
		{
			field: 'REFUND MODE',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 73,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
				>
					<p className="table-header__label_invoices mb-0">
						<p className="d-none d-lg-block mb-0">REFUND MODE</p>
						<p className="d-block d-lg-none mb-0">REFUND</p>
						<span className="sort-icon">{sortIconMap[sortDirection?.payment_mode]}</span>
					</p>
				</div>
			),
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 72,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortDataList({ order_by: 'asc', sort_by: 'bill_total' })}
				>
					<p className="d-flex align-items-center justify-content-end text-dark  table-header__label_invoices mb-0">
						AMOUNT
						<span className="sort-icon">{sortIconMap[sortDirection?.bill_total]}</span>
					</p>
				</div>
			),
		},
	];

	return (
		<div>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					buttonName: 'Create New Sales Return',
					disabled: !hasPermission('sales.sales_return.create', user?.role?.role_permissions),
					handler: () => navigate(`/user/${suburl}/sales-return-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						disabled: !hasPermission('sales.sales_return.delete', user?.role?.role_permissions),
						button: 'Delete',
						handler: () => {
							handleOpenBulkReturnModal();
						},
					},
					{
						id: 2,
						className: 'btn-gray',
						button: 'Download Pdf',
						disabled: !hasPermission(
							'sales.sales_return.download_print_pdf',
							user?.role?.role_permissions,
						),
						handler: () => {
							handlePrintAndDownloadPdf('', 'download', true);
						},
					},

					{
						id: 3,
						className: 'btn-gray',
						disabled: !hasPermission(
							'sales.sales_return.download_print_pdf',
							user?.role?.role_permissions,
						),
						button: 'Print',
						handler: () => {
							handlePrintAndDownloadPdf('', 'print', true);
						},
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Drafts')}
								>
									Drafts
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Pending Approval')}
								>
									Pending Approval
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Approved')}
								>
									Approved
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Declined')}
								>
									Declined
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Receive Pending')}
								>
									Receive Pending
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Received')}
								>
									Received
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Refunded')}
								>
									Refunded
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Sales Return');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<Button
							type="button"
							button="Advanced Filters"
							className="mt-0 px-4 btn-primary"
							onClick={() => setIsAdvanceFilterOpen(true)}
							icon={advanceFilterIcon}
						/>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
							onClick={(e) => e.preventDefault()}
						>
							<img src={sortbydot} />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser"
							style={{ minWidth: '240px' }}
						>
							<li style={{ cursor: 'pointer' }}>
								<a
									className="dropdown-item"
									style={{
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px',
										fontWeight: 'bold',
										justifyContent: 'space-between',
									}}
									onClick={(e) => {
										e.stopPropagation();
										setIsSortBy(!isSortBy);
									}}
								>
									Sort By
									<span>{isSortBy ? '▼' : '▶'}</span>
								</a>
							</li>
							{isSortBy ? (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'created_at' })}
										>
											Create Time
											<span>{sortIconMap[sortDirection?.created_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
										>
											Last Modified Time
											<span>{sortIconMap[sortDirection?.updated_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
										>
											Date
											<span>{sortIconMap[sortDirection?.date]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'return_number' })}
										>
											Sales Return #<span>{sortIconMap[sortDirection?.return_number]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
										>
											Customer Name
											<span>{sortIconMap[sortDirection?.customer_name]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'bill_total' })}
										>
											Amount
											<span>{sortIconMap[sortDirection?.bill_total]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
										>
											Payment Mode
											<span>{sortIconMap[sortDirection?.payment_mode]}</span>
										</a>
									</li>
								</>
							) : (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className={`dropdown-item ${!hasPermission('sales.sales_return.import', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => {}}
										>
											Import Return
										</a>
									</li>

									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className={`dropdown-item ${!hasPermission('sales.sales_return.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => {
												exportTableData('return');
											}}
										>
											Export Return
										</a>
									</li>

									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'id' })}
										>
											Refresh
											<span>{sortIconMap[sortDirection?.id]}</span>
										</a>
									</li>
								</>
							)}
						</ul>
					</div>
				}
			/>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Sales Return');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : salesReturn.data.length > 0 ? (
				<Table
					row={salesReturn.data}
					coloum={salesReturnColumn}
					className="productTable"
					onRowClick={onRowClick}
					bulkAction={bulkAction}
					action={setBulkAction}
					style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
					onDeselectAll={handleDeselectAll}
				/>
			) : (
				<DataNotFound
					title={'Handle your sales returns with confidence!'}
					subtitle={'Manage refunds and returns—all in one place.'}
					descriptionTitle={''}
					descriptionSubTitle={'Keep your sales returns organized to improve customer '}
					descriptionContent={'satisfaction.'}
					buttonText={'Create New Sales Return'}
					disabled={!hasPermission('sales.sales_return.create', user?.role?.role_permissions)}
					onClick={() => navigate(`/user/${suburl}/sales-return-create`)}
				/>
			)}
			{salesReturn.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : salesReturnParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : salesReturn.totalPages}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : salesReturnParams.page_size}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setSalesReturnParams((prev) => ({
								...prev,
								page_size: value,
								page: 1,
							}));
						}
					}}
				/>
			)}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.sales_return}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
			{isBulkDeleteModelOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsBulkDeleteModalOpen}
					isAlertModelOpen={isBulkDeleteModelOpen}
					objectSelectedList={deleteBulkReturnList}
					objectLength={deleteBulkReturnList?.length}
					customText={'Are you sare you want to delete'}
					saleTypeName={'Sales Return'}
					title={'Sales Return Delete'}
					handleBulk={handleBulkDeleteSalesReturn}
				/>
			)}
		</div>
	);
};
export default SalesReturn;
